// ADDED
import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const leaveIncentiveBatchService = {
  getPreview: async (apiFilterPayload, additionalFilters) => {
    const payload = {
      apiFilterPayload: apiFilterPayload,
      additionalApiFilterPayload: additionalFilters
    };
    return await axios.post(`${domain}/api/LeaveIncentive/preview`, payload, { headers });
  },

  getPreviewByEmployee: async (id) => axios.get(`${domain}/api/LeaveIncentive/preview/${id}`, { headers }),

  getById: async (id) => axios.get(`${domain}/api/LeaveIncentive/${id}`, { headers }),

  process: async (param) => axios.post(`${domain}/api/LeaveIncentive/process`, param, { headers }),

  revert: async (param) => axios.post(`${domain}/api/LeaveIncentive/revert`, param, { headers }),

  release: async (id) => axios.post(`${domain}/api/LeaveIncentive/release/${id}`, {}, { headers }),
};

export default leaveIncentiveBatchService;